import React from 'react';
import Table from '../Table/Table';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import style from './ShareStatistics.module.css';


function formatNumber(number) {
  if (number === undefined || isNaN(number)) {
    return "-";
  }

  if (number >= 1e12) {
    return `$${(number / 1e12).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Trillion`;
  } else if (number >= 1e9) {
    return `$${(number / 1e9).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Billion`;
  } else if (number >= 1e6) {
    return `$${(number / 1e6).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Million`;
  } else {
    return `$${number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}


function formatNumberExact(number) {
  return number?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) ?? '-';
}

function numericOrNull(value) {
  if (value === null || value === undefined || value === '' || value === '-') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function positiveOrNull(value) {
  const number = numericOrNull(value);
  if (number === null || number <= 0) return null;
  return number;
}


const ShareStatistics = ({ share_statistics = {} }) => {
  if (share_statistics === null) {
    return (
      <div>
        <h3 className={style.headline}>Share Statistics</h3>
        <p className={style.noData}>No data</p>
      </div>
    );
  }
  const dividendRate = positiveOrNull(share_statistics["ttm_dividend_rate"]);
  const dividendYield = positiveOrNull(share_statistics["dividend_yield"]);

  return (
    <div>
      <h3 className={style.headline}>Share Statistics</h3>
      <div>
        <Table>
          <tbody>
            <tr>
              <th>Market cap</th>
              <td className={style.points}>{formatNumber(share_statistics["market_cap"])}</td>
            </tr>
            <tr>
              <th>
                <InfoTooltip content="Market cap plus debt, minus cash." label="Enterprise value definition">
                  Enterprise Value
                </InfoTooltip>
              </th>
              <td className={style.points}>{formatNumber(share_statistics["enterprise_value"])} </td>
            </tr>
            {dividendRate !== null && (
              <tr>
                <th>Annual dividend</th>
                <td className={style.points}>${dividendRate.toFixed(2)}</td>
              </tr>
            )}
            {dividendYield !== null && (
              <tr>
                <th>Dividend yield</th>
                <td className={style.points}>{dividendYield.toFixed(2)}%</td>
              </tr>
            )}
            <tr>
              <th>Earnings per Share</th>
              <td className={style.points}>${share_statistics["earnings_per_share"] ?? '-'} </td>
            </tr>
            <tr>
              <th>
                <InfoTooltip content="1 moves with the market. Above 1 tends to swing more." label="Beta definition">
                  Beta
                </InfoTooltip>
              </th>
              <td className={style.points}>{share_statistics["beta"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Outstanding Shares</th>
              <td className={style.points}>{formatNumberExact(share_statistics["shares_outstanding"])}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ShareStatistics;
